var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{staticClass:"movie-backdrop",attrs:{"src":_vm.movieBackdrop,"alt":'Movie poster'}})}
var staticRenderFns = []

export { render, staticRenderFns }